









import { Component, Ref, Vue } from 'vue-property-decorator'

import NoteTree from '@/views/pages/genealogy/note/components/NoteTree.vue'

@Component({
  components: {
    NoteTree
  }
})
export default class extends Vue {
  backToGenealogyMain () {
    let routerName = 'genealogyManageAll'
    if (this.$route.query.type === 'family') {
        routerName = 'familyManageAll'
    }
    this.$router.push({
      name: routerName
    })
  }
}
